@if (!isFullscreenRoute()) {
  <ls-header [hideSearchOn]="hideSearchOn" />
}

<main class="ls-main-content" [class.ls-main-contained]="isAdminRoute()">
  <router-outlet />
</main>

@if (!isFullscreenRoute()) {
  <ls-footer />
}

<!-- Montée hors du bloc "!isFullscreenRoute()" : la barre de lecture doit rester visible
     partout sur le site sans exception (admin, karaoké, projection compris), cf. demande
     explicite de l'utilisateur. -->
@if (isPlayerActive()) {
  <ls-player-bar />
}

<!-- Navigation mobile (tab bar fixe en bas, <860px) — sur toutes les pages sauf
     karaoké/projection/get-started ; /admin monte la sienne dans admin-layout. -->
@if (showTabbar()) {
  <ls-tabbar />
}

<!-- Consentement Google Analytics (invisible si aucun ID GA n'est configuré). -->
<ls-consent-banner />

@if (auth.popupPending()) {
  <app-login-popup-overlay />
}

<!-- Toast global — un seul point de montage pour toute l'app (admin + public), cf. décision
     utilisateur "pk le toast n'est pas réutilisable genre un composant" / "pk ce n'est pas un
     service". Deux modes : texte simple (message/type) et HTML riche (icône/actions inline, ex.
     bouton "Annuler" de playlist-detail) via ToastService.showHtml(). -->
@if (toastService.toast(); as t) {
  @if (t.html) {
    <div class="app-toast" [innerHTML]="t.html" (click)="toastService.handleClick($event)"></div>
  } @else {
    <div
      class="app-toast"
      [class.success]="t.type === 'success'"
      [class.error]="t.type === 'error'"
    >
      @if (t.type === 'success') {
        <i class="ls-check"></i>
      }
      @if (t.type === 'error') {
        <i class="ls-alert-circle"></i>
      }
      {{ t.message }}
    </div>
  }
}
